export default function Go_Operators () {
  return (
    <div>
      <h1>Go_Operators </h1>
      <p>Operators</p>
    </div>
  );
}